import './AccountsPlanQuiz.css';
import '../../chaptercontainer.css'

const normalizeAccountsPlanOption = (option, index) => {
  if (
    option &&
    typeof option === 'object' &&
    option.account !== undefined
  ) {
    return {
      ...option,
      account: String(option.account).trim(),
      __origIndex: index,
    };
  }

  return {
    account: String(option).trim(),
    __origIndex: index,
  };
};

const AccountsPlanQuiz = ({
  question,
  selectedAccountOption,
  isAnswerChecked,
  answerStatus,
  onSelectAccount,
  onRemoveAccount
}) => {

  const normalizedOptions = (question?.options || []).map(
    (option, index) =>
      normalizeAccountsPlanOption(option, index)
  );

  const selectedAccountKey = selectedAccountOption
    ? String(selectedAccountOption.account)
    : null;

  const effectiveAvailableOptions =
    normalizedOptions.filter(
      (option) =>
        String(option.account) !== selectedAccountKey
    );

  const handleDragStartOption = (event, account) => {
    if (isAnswerChecked) return;

    event.dataTransfer.setData(
      'text/plain',
      String(account)
    );

    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOverBlank = (event) => {
    event.preventDefault();
  };

  const handleDropOnBlank = (event) => {
    event.preventDefault();

    if (isAnswerChecked) return;

    const account =
      event.dataTransfer.getData('text/plain');

    if (!account) return;

    const pickedOption = normalizedOptions.find(
      (option) =>
        String(option.account) === String(account)
    );

    if (!pickedOption) return;

    onSelectAccount(pickedOption);
  };

  const handleDragStartBlank = (event) => {
    if (
      !selectedAccountOption ||
      isAnswerChecked
    ) {
      return;
    }

    event.dataTransfer.setData(
      'text/plain',
      `fromBlank:${selectedAccountOption.account}`
    );

    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDropOnOptionsArea = (event) => {
    event.preventDefault();

    if (isAnswerChecked) return;

    const raw =
      event.dataTransfer.getData('text/plain');

    if (
      !raw ||
      !raw.startsWith('fromBlank:')
    ) {
      return;
    }

    onRemoveAccount();
  };

  const handleSelectByClick = (account) => {
    if (isAnswerChecked) return;

    const option = normalizedOptions.find(
      (item) =>
        String(item.account) === String(account)
    );

    if (!option) return;

    onSelectAccount(option);
  };

  const handleBlankClick = () => {
    if (
      !selectedAccountOption ||
      isAnswerChecked
    ) {
      return;
    }

    onRemoveAccount();
  };

  return (
    <div className="accounts-plan-container">

    <div className='quiz-content-scroll-bc'>
      <div className="accounts-plan-card">

        <div className="accounts-plan-statement">

          <div className="accounts-plan-blank-row">
            <div
              className={`
                accounts-plan-blank-box
                ${selectedAccountOption ? 'filled' : ''}
                ${
                  isAnswerChecked
                    ? answerStatus === 'correct'
                      ? 'correct'
                      : 'incorrect'
                    : ''
                }
              `}
              onDragOver={handleDragOverBlank}
              onDrop={handleDropOnBlank}
              draggable={
                !!selectedAccountOption &&
                !isAnswerChecked
              }
              onDragStart={handleDragStartBlank}
              onClick={handleBlankClick}
              role="button"
              tabIndex={0}
            >
              {selectedAccountOption ? (
                <span className="accounts-plan-blank-value">
                  {selectedAccountOption.account}
                </span>
              ) : (
                <span className="accounts-plan-blank-placeholder" />
              )}
            </div>
          </div>

          <div
            className="accounts-plan-text"
            dangerouslySetInnerHTML={{
              __html: question?.statement || ''
            }}
          />

        </div>

        <p className="accounts-plan-label">
          alege codul contului:
        </p>

        <div className="accounts-plan-options">
          <div
            className="accounts-plan-options-row"
            onDragOver={(event) =>
              event.preventDefault()
            }
            onDrop={handleDropOnOptionsArea}
          >
            {normalizedOptions.map(
              (originalOption) => {

                const isAvailable =
                  effectiveAvailableOptions.some(
                    (option) =>
                      String(option.account) ===
                      String(originalOption.account)
                  );

                const isSelected =
                  selectedAccountOption &&
                  String(
                    selectedAccountOption.account
                  ) ===
                    String(
                      originalOption.account
                    );

                const isCorrect =
                  isAnswerChecked &&
                  String(
                    originalOption.account
                  ).trim() ===
                    String(
                      question.correctAccount
                    ).trim();

                const isIncorrect =
                  isAnswerChecked &&
                  isSelected &&
                  String(
                    originalOption.account
                  ).trim() !==
                    String(
                      question.correctAccount
                    ).trim();

                if (isAvailable) {
                  return (
                    <button
                      key={originalOption.account}
                      type="button"
                      className={`
                        accounts-plan-option-btn
                        ${isSelected ? 'selected' : ''}
                        ${isCorrect ? 'correct' : ''}
                        ${isIncorrect ? 'incorrect' : ''}
                      `}
                      draggable={!isAnswerChecked}
                      onDragStart={(event) =>
                        handleDragStartOption(
                          event,
                          originalOption.account
                        )
                      }
                      onClick={() =>
                        handleSelectByClick(
                          originalOption.account
                        )
                      }
                      disabled={isAnswerChecked}
                    >
                      <div className="accounts-plan-opt-number">
                        {originalOption.account}
                      </div>
                    </button>
                  );
                }

                return (
                  <div
                    key={`ph-${originalOption.account}`}
                    className="accounts-plan-option-placeholder"
                  />
                );
              }
            )}
          </div>
        </div>

      </div>

      </div>


    </div>
  );
};

export default AccountsPlanQuiz;